// removed by extract-text-webpack-plugin
module.exports = {"component":"_1F5_js45yz2pd9YUTgnVRf","header":"jJU9S2swXj8Glhtv5sOuA","messagePlaceholder":"_3j8QxBUR9-M3NKPRVclJzu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Appointments/PastAppointments/PastAppointmentsContainer.css
// module id = 1405
// module chunks = 0